import axios from 'axios';

const cepApi = axios.create({
  baseURL: `/cep_api`
});

export default cepApi;
